// listProfile returns body as a single profile object (or null when the user
// does not exist). Legacy MySQL stringifies TINYINT 1/0; v2 Prisma returns boolean.
export const isFirstTimeSignUp = (pInfo) => {
  const flag = pInfo?.body?.firstTimeSignUp;
  return flag === 1 || flag === '1' || flag === true;
};
